import script from "./UserMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserMenu.vue?vue&type=script&setup=true&lang=ts"

import "./UserMenu.vue?vue&type=style&index=0&id=da428ea2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da428ea2"]])

export default __exports__